import { Flex, Text } from '@optiaxiom/react';

import ConnectionsEmptyState from '@frontend/assets/ConnectionsEmptyState.svg';

export default function Empty() {
  return (
    <Flex alignItems="center" gap="24" maxW="lg">
      <img src={ConnectionsEmptyState} alt="Instructions Settings Empty State" />
      <Text color="fg.tertiary" fontSize="md" textAlign="center">
        Oops! It seems you don&apos;t have any product instance to connect yet. Please Contact
        Optimizely for further assistance on this.
      </Text>
    </Flex>
  );
}
